import apiInvoices from "@/services/api.invoices";

const state = {
    allInvoices: [],
    sizeStatusInvoices: {},
    filterAllInvoices: [],
    efdInvoice: [],
    behalfList: [],
    amountSummariesInvoice: {},
    newEfdInvoice: [],
    newInvoices: {},
    currentInvoice: {},
    upCurrentInvoice: {},
    invoiceShared: {},
    paymentInvoice: {},
    paymentLink: '',
    updateCurrentInvoiceStatus: {},
    isLoadingAllInvoices: false,
    isLoadingCreateNewInvoices: false,
    isLoadingCurrentInvoice: false,
    isLoadingChangeCurrentInvoice: false,
    isLoadingUpdateCurrentInvoiceStatus: false,
    isLoadingInvoiceShared: false,
    isLoadingPaymentInvoice: false,
    isLoadingBehalfLIst: false,
    isLoadingAmountSummariesInvoice: false,
    isLoadingDeleteInvoice: false
}

export const mutationTypes = {
    allInvoicesStart: '[invoices] All invoices start',
    allInvoicesSuccess: '[invoices] All invoices success',
    allInvoicesFailure: '[invoices] All invoices failure',

    createNewInvoicesStart: '[invoices] Create new invoices start',
    createNewInvoicesSuccess: '[invoices] Create new invoices success',
    createNewInvoicesFailure: '[invoices] Create new invoices failure',

    currentInvoiceStart: '[invoices] Current invoice start',
    currentInvoiceSuccess: '[invoices] Current invoice success',
    currentInvoiceFailure: '[invoices] Current invoice failure',

    changeCurrentInvoiceStart: '[invoices] Change current invoice start',
    changeCurrentInvoiceSuccess: '[invoices] Change current invoice success',
    changeCurrentInvoiceFailure: '[invoices] Change current invoice failure',

    updateInvoiceStatusStart: '[invoices] Update current invoice status start',
    updateInvoiceStatusSuccess: '[invoices] Update current invoice status success',
    updateInvoiceStatusFailure: '[invoices] Update current invoice status failure',

    findInvoiceSharedStart: '[invoices] Find invoice shared start',
    findInvoiceSharedSuccess: '[invoices] Find invoice shared success',
    findInvoiceSharedFailure: '[invoices] Find invoice shared failure',

    paymentInvoiceStart: '[invoices] Payment invoice start',
    paymentInvoiceSuccess: '[invoices] Payment invoice success',
    paymentInvoiceFailure: '[invoices] Payment invoice failure',

    filterAllInvoicesStart: '[invoices] Filter all invoices start',

    targetEfdInvoiceStart: '[invoices] Target EFD invoice start',
    targetEfdInvoiceSuccess: '[invoices] Target EFD invoice success',
    targetEfdInvoiceFailure: '[invoices] Target EFD invoice failure',

    filterEfdInvoiceSuccess: '[invoices] Filter EFD Invoice',

    behalfListStart: '[invoices] Behalf list start',
    behalfListSuccess: '[invoices] Behalf list success',
    behalfListFailure: '[invoices] Behalf list failure',

    amountSummariesInvoiceStart: '[invoices] Amount summaries invoice start',
    amountSummariesInvoiceSuccess: '[invoices] Amount summaries invoice success',
    amountSummariesInvoiceFailure: '[invoices] Amount summaries invoice failure',

    deleteCurrentInvoiceStart: '[invoices] Delete current invoice start',
    deleteCurrentInvoiceSuccess: '[invoices] Delete current invoice success',
    deleteCurrentInvoiceFailure: '[invoices] Delete current invoice failure',
}

export const actionTypes = {
    findSearchInvoices: '[invoices] Find all invoices',
    createNewInvoices: '[invoices] Create new invoices',
    findCurrentInvoice: '[invoices] Find current invoice',
    changeCurrentInvoice: '[invoices] Change current invoice',
    updateInvoiceStatus: '[invoices] Update current invoice status',
    getInvoiceShared: '[invoices] Get invoice shared',
    sendStripePaymentInvoice: '[invoices] Send Stripe Payment Invoice',
    sendTripleaPaymentInvoice: '[invoices] Send Triplea Payment Invoice',
    filterAllInvoices: '[invoices] Filter all invoices',
    targetEfdInvoice: '[invoices] Target EFD invoice',
    filterEfdInvoice: '[invoices] Filter EFD invoice',
    getBehalfList: '[invoices] Get behalf list',
    getAmountSummariesInvoice: '[invoices] Get amount summaries invoice',
    deleteInvoice: '[invoices] Deleted invoice'
}

export const getterTypes = {
    allInvoices: '[invoices] All invoices',
    sizeStatusInvoices: '[invoices] Size status invoices',
    newInvoices: '[invoices] New invoices',
    isLoadingCreateNewInvoices: '[invoices] Is loading created new invoices',
    isLoadingAllInvoices: '[invoices] Is loading all invoices',
    isLoadingCurrentInvoice: '[invoices] Is loading current invoice',
    currentInvoice: '[invoices] Current invoice',
    upCurrentInvoice: '[invoices] Up current invoice',
    isLoadingChangeCurrentInvoice: '[invoices] Is loading change current invoice',
    updateCurrentInvoiceStatus: '[invoices] Update current invoice status',
    isLoadingUpdateCurrentInvoiceStatus: '[invoices] Is Loading Update Current Invoice Status',
    invoiceShared: '[invoices] Invoice shared',
    isLoadingInvoiceShared: '[invoices] Is loading invoice shared',
    paymentInvoice: '[invoices] Payment invoice',
    isLoadingPaymentInvoice: '[invoice] Is loading payment invoice',
    filterAllInvoices: '[invoices] Filter all invoice',
    efdInvoice: '[invoices] EFD invoice',
    newEfdInvoice: '[invoices] New EVD invoice',
    paymentLink: '[invoices] Payment link',
    behalfList: '[invoices] Behalf list',
    isLoadingBehalfLIst: '[invoices] Is loading behalf list',
    amountSummariesInvoice: '[invoice] Amount Summaries invoice',
    isLoadingAmountSummariesInvoice: '[invoice] Is loading amount summaries invoice'
}

const getters = {
    [getterTypes.allInvoices]: (state) => {
        return state.allInvoices
    },
    [getterTypes.sizeStatusInvoices]: (state) => {
      return state.sizeStatusInvoices
    },
    [getterTypes.newInvoices]: (state) => {
        return state.newInvoices
    },
    [getterTypes.isLoadingCreateNewInvoices]: (state) => {
        return state.isLoadingCreateNewInvoices
    },
    [getterTypes.isLoadingAllInvoices]: (state) => {
        return state.isLoadingAllInvoices
    },
    [getterTypes.currentInvoice]: (state) => {
        return state.currentInvoice
    },
    [getterTypes.isLoadingCurrentInvoice]: (state) => {
        return state.isLoadingCurrentInvoice
    },
    [getterTypes.upCurrentInvoice]: (state) => {
        return state.upCurrentInvoice
    },
    [getterTypes.isLoadingChangeCurrentInvoice]: (state) => {
        return state.isLoadingChangeCurrentInvoice
    },
    [getterTypes.updateCurrentInvoiceStatus]: (state) => {
        return state.updateCurrentInvoiceStatus
    },
    [getterTypes.isLoadingUpdateCurrentInvoiceStatus]: (state) => {
        return state.isLoadingUpdateCurrentInvoiceStatus
    },
    [getterTypes.invoiceShared]: (state) => {
        return state.invoiceShared
    },
    [getterTypes.isLoadingInvoiceShared]: (state) => {
        return state.isLoadingInvoiceShared
    },
    [getterTypes.paymentInvoice]: (state) => {
        return state.paymentInvoice
    },
    [getterTypes.isLoadingPaymentInvoice]: (state) => {
        return state.isLoadingPaymentInvoice
    },
    [getterTypes.filterAllInvoices]: (state) => {
        return state.filterAllInvoices
    },
    [getterTypes.efdInvoice]: (state) => {
        return state.efdInvoice
    },
    [getterTypes.newEfdInvoice]: (state) => {
        return state.newEfdInvoice
    },
    [getterTypes.paymentLink]: (state) => {
        return state.paymentLink
    },
    [getterTypes.behalfList]: (state) => {
        return state.behalfList
    },
    [getterTypes.isLoadingBehalfLIst]: (state) => {
        return state.isLoadingBehalfLIst
    },
    [getterTypes.amountSummariesInvoice]: (state) => {
        return state.amountSummariesInvoice
    },
    [getterTypes.isLoadingAmountSummariesInvoice]: (state) => {
        return state.isLoadingAmountSummariesInvoice
    }
}

const mutations = {
    [mutationTypes.allInvoicesStart](state) {
        state.isLoadingAllInvoices = true
    },
    [mutationTypes.allInvoicesSuccess](state, payload) {
        state.isLoadingAllInvoices = false
        state.sizeStatusInvoices = payload.totalCount
        state.allInvoices = payload.results.map(i => {
            let newInvoice = Object.assign({menu: false}, i)
            return newInvoice
        })
        state.efdInvoice = payload.results.filter(i => i.status === 'PAID' || i.status === 'PARTIALLY')
    },
    [mutationTypes.allInvoicesFailure](state) {
        state.isLoadingAllInvoices = false
    },
    [mutationTypes.createNewInvoicesStart](state) {
        state.isLoadingCreateNewInvoices = true
    },
    [mutationTypes.createNewInvoicesSuccess](state, payload) {
        state.isLoadingCreateNewInvoices = false
        state.newInvoices = payload
    },
    [mutationTypes.createNewInvoicesFailure](state){
        state.isLoadingCreateNewInvoices = false
    },
    [mutationTypes.currentInvoiceStart](state){
        state.isLoadingCurrentInvoice = true
    },
    [mutationTypes.currentInvoiceSuccess](state, payload) {
        state.isLoadingCurrentInvoice = false
        state.currentInvoice = payload
    },
    [mutationTypes.currentInvoiceFailure](state) {
        state.isLoadingCurrentInvoice = false
    },
    [mutationTypes.changeCurrentInvoiceStart](state) {
        state.isLoadingChangeCurrentInvoice = true
    },
    [mutationTypes.changeCurrentInvoiceSuccess](state, payload) {
        state.isLoadingChangeCurrentInvoice = false
        state.upCurrentInvoice = payload
    },
    [mutationTypes.updateInvoiceStatusStart](state){
        state.isLoadingUpdateCurrentInvoiceStatus = true
    },
    [mutationTypes.updateInvoiceStatusSuccess](state, payload) {
        state.isLoadingUpdateCurrentInvoiceStatus = false
        state.updateCurrentInvoiceStatus = payload
    },
    [mutationTypes.updateInvoiceStatusFailure](state) {
        state.isLoadingUpdateCurrentInvoiceStatus = false
    },
    [mutationTypes.findInvoiceSharedStart](state) {
        state.isLoadingInvoiceShared = true
    },
    [mutationTypes.findInvoiceSharedSuccess](state, payload) {
        state.invoiceShared = payload

        state.isLoadingInvoiceShared = false
    },
    [mutationTypes.findInvoiceSharedFailure](state) {
        state.isLoadingInvoiceShared = false
    },
    [mutationTypes.paymentInvoiceStart](state) {
        state.isLoadingPaymentInvoice = true
    },
    [mutationTypes.paymentInvoiceSuccess](state, payload) {
        state.isLoadingPaymentInvoice = false
        state.paymentLink = payload
    },
    [mutationTypes.paymentInvoiceFailure](state) {
        state.isLoadingPaymentInvoice = false
    },
    [mutationTypes.filterAllInvoicesStart](state, payload) {
        if (payload === 0) {
            const newAllInvoice = state.allInvoices.filter(i => i.status === 'SENT')
            state.filterAllInvoices = newAllInvoice
        }
        if (payload === 1) {
            const newAllInvoice = state.allInvoices.filter(i => i.status === 'PAID' || i.status === 'PARTIALLY')
            state.filterAllInvoices = newAllInvoice
        }
        if (payload === 2) {
            const newAllInvoice = state.allInvoices.filter(i => i.status === 'CANCEL' || i.status === 'REFUND')
            state.filterAllInvoices = newAllInvoice
        }
    },
    [mutationTypes.targetEfdInvoiceStart](state) {
        state.isLoadingAllInvoices = true
    },
    [mutationTypes.targetEfdInvoiceSuccess](state) {
        state.isLoadingAllInvoices = false
    },
    [mutationTypes.targetEfdInvoiceFailure](state) {
        state.isLoadingAllInvoices = false
    },
    [mutationTypes.filterEfdInvoiceSuccess](state, payload) {
        // console.log(payload)
        if (payload === 0) {
            const newArrInvoice = state.efdInvoice.filter(i => i.efd === false)
            state.newEfdInvoice = newArrInvoice
        }

        if (payload === 1) {
            const newArrInvoice = state.efdInvoice.filter(i => i.efd === true)
            state.newEfdInvoice = newArrInvoice
        }
    },
    [mutationTypes.behalfListStart](state){
        state.isLoadingBehalfLIst = true
    },
    [mutationTypes.behalfListSuccess](state, list){
        state.isLoadingBehalfLIst = false
        state.behalfList = list
    },
    [mutationTypes.behalfListFailure](state){
        state.isLoadingBehalfLIst = false
    },
    [mutationTypes.amountSummariesInvoiceStart](state){
        state.isLoadingAmountSummariesInvoice = true
    },
    [mutationTypes.amountSummariesInvoiceSuccess](state, data) {
        state.isLoadingAmountSummariesInvoice = false
        state.amountSummariesInvoice = data
    },
    [mutationTypes.amountSummariesInvoiceFailure](state) {
        state.isLoadingAmountSummariesInvoice = false
    },
    [mutationTypes.deleteCurrentInvoiceStart](state) {
        state.isLoadingDeleteInvoice = true
    },
    [mutationTypes.deleteCurrentInvoiceSuccess](state) {
        state.isLoadingDeleteInvoice = false
    },
    [mutationTypes.deleteCurrentInvoiceFailure](state) {
        state.isLoadingDeleteInvoice = false
    }
}

const actions = {
    [actionTypes.findSearchInvoices](context, payload) {
        return new Promise((resolve) => {
            context.commit(mutationTypes.allInvoicesStart)
            apiInvoices
                .getSearchInvoice(payload)
                .then((response) => {
                    context.commit(mutationTypes.allInvoicesSuccess, response.data)
                    resolve(response)
                })
                .catch((result) => {
                    context.commit(mutationTypes.allInvoicesFailure, result.response.data)
                })
        })
    },
    [actionTypes.createNewInvoices](context, payload) {
        return new Promise((resolve, reject) => {
            context.commit(mutationTypes.createNewInvoicesStart)
            apiInvoices.createdInvoices(payload)
                .then((response) => {
                    context.commit(mutationTypes.createNewInvoicesSuccess, response.data)
                    resolve(response)
                })
                .catch((result) => {
                    context.commit(mutationTypes.createNewInvoicesFailure)
                    reject(result)
                })
        })
    },
    [actionTypes.findCurrentInvoice](context, payload) {
        return new Promise((resolve, reject) => {
            context.commit(mutationTypes.currentInvoiceStart)
            apiInvoices
                .getCurrentInvoice(payload)
                .then((response) => {
                    context.commit(mutationTypes.currentInvoiceSuccess, response.data)
                    resolve(response)
                })
                .catch((result) => {
                    context.commit(mutationTypes.currentInvoiceFailure)
                    reject(result)
                })
        })
    },
    [actionTypes.changeCurrentInvoice](context, payload) {
        return new Promise((resolve, reject) => {
            context.commit(mutationTypes.changeCurrentInvoiceStart)
            apiInvoices
                .changeCurrentInvoice(payload)
                .then((response) => {
                    context.commit(mutationTypes.changeCurrentInvoiceSuccess, response.data)
                    resolve(response)
                })
                .catch((result) => {
                    context.commit(mutationTypes.changeCurrentInvoiceFailure)
                    reject(result)
                })
        })
    },
    [actionTypes.updateInvoiceStatus](context, payload){
        return new Promise((resolve, reject) => {
            context.commit(mutationTypes.updateInvoiceStatusStart)
            apiInvoices
                .updateCurrentInvoiceStatus(payload)
                .then((response) => {
                    context.commit(mutationTypes.updateInvoiceStatusSuccess, response.data)
                    resolve(response)
                })
                .catch((result) => {
                    context.commit(mutationTypes.updateInvoiceStatusFailure)
                    reject(result)
                })
        })
    },
    [actionTypes.getInvoiceShared](context, payload) {
        return new Promise((resolve, reject) => {
            context.commit(mutationTypes.findInvoiceSharedStart)
            apiInvoices
                .getInvoiceShared(payload)
                .then((response) => {
                    context.commit(mutationTypes.findInvoiceSharedSuccess, response.data)
                    resolve(response)
                })
                .catch((result) => {
                    context.commit(mutationTypes.findInvoiceSharedFailure)
                    reject(result)
                })
        })
    },
    [actionTypes.sendStripePaymentInvoice](context, payload) {
        return new Promise((resolve, reject) => {
            context.commit(mutationTypes.paymentInvoiceStart)
            apiInvoices
                .createStripeSession(payload)
                .then((response) => {
                    context.commit(mutationTypes.paymentInvoiceSuccess, response.data)
                    resolve(response)
                })
                .catch((result) => {
                    context.commit(mutationTypes.paymentInvoiceFailure)
                    reject(result)
                })
        })
    },
    [actionTypes.sendTripleaPaymentInvoice](context, payload) {
        return new Promise((resolve, reject) => {
            context.commit(mutationTypes.paymentInvoiceStart)
            apiInvoices
                .createTripleaPayment(payload)
                .then((response) => {
                    context.commit(mutationTypes.paymentInvoiceSuccess, response.data.url)
                    resolve(response)
                })
                .catch((result) => {
                    context.commit(mutationTypes.paymentInvoiceFailure)
                    reject(result)
                })
        })
    },
    [actionTypes.filterAllInvoices](context, payload){
        context.commit(mutationTypes.filterAllInvoicesStart, payload)
    },
    [actionTypes.targetEfdInvoice](context, payload) {
        return new Promise((resolve, reject) => {
            context.commit(mutationTypes.filterAllInvoicesStart)
            apiInvoices
                .targetEfdInvoice(payload)
                .then((response) => {
                    context.commit(mutationTypes.targetEfdInvoiceSuccess, response.data)
                    resolve(response)
                })
                .catch((result) => {
                    context.commit(mutationTypes.targetEfdInvoiceFailure)
                    reject(result)
                })
        })
    },
    [actionTypes.filterEfdInvoice](context, payload){
        context.commit(mutationTypes.filterEfdInvoiceSuccess, payload)
    },
    [actionTypes.getBehalfList](context, payload){
        return new Promise((resolve, reject) => {
            context.commit(mutationTypes.behalfListStart)
            apiInvoices
                .getBehalfList(payload)
                .then(response => {
                    context.commit(mutationTypes.behalfListSuccess, response.data)
                    resolve(response)
                })
                .catch(error => {
                    context.commit(mutationTypes.behalfListFailure)
                    reject(error)
                })
        })
    },
    [actionTypes.getAmountSummariesInvoice](context, payload){
        return new Promise((resolve, reject) => {
            context.commit(mutationTypes.amountSummariesInvoiceStart)
            apiInvoices
                .getAmountSummariesInvoice(payload)
                .then((response) => {
                    context.commit(mutationTypes.amountSummariesInvoiceSuccess, response.data)
                    resolve(response)
                })
                .catch((error) => {
                    context.commit(mutationTypes.amountSummariesInvoiceFailure)
                    reject(error)
                })
        })
    },
    [actionTypes.deleteInvoice](context, payload) {
        return new Promise((resolve, reject) => {
            context.commit(mutationTypes.deleteCurrentInvoiceStart)
            apiInvoices
                .deleteCurrentInvoice(payload)
                .then(response => {
                    context.commit(mutationTypes.deleteCurrentInvoiceSuccess)
                    resolve(response)
                })
                .catch(error => {
                    context.commit(mutationTypes.deleteCurrentInvoiceFailure)
                    reject(error)
                })
        })
    }
}

export default {
    state,
    actions,
    mutations,
    getters,
}
